import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { TranslateService } from '@ngx-translate/core';
import { ModalTemplateComponent } from '../modal-template/modal-template.component';
import { PencilButtonComponent } from '../../pencil-button/pencil-button.component';
import {
  ConfirmationModalComponent,
  ModalData,
} from '../confirmation-modal/confirmation-modal.component';

export type ConsentModalData = ModalData & { consentCheckboxLabel: string };

@Component({
  selector: 'app-consent-modal',
  standalone: true,
  imports: [CommonModule, ModalTemplateComponent, PencilButtonComponent, MatDialogModule],
  templateUrl: './consent-modal.component.html',
  styleUrls: ['./consent-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentModalComponent extends ConfirmationModalComponent {
  @Input() consentCheckboxLabel = '';
  isConsentGiven = false;

  constructor(
    @Optional() dialogRef: MatDialogRef<ConsentModalComponent>,
    @Optional() bottomSheetRef: MatBottomSheetRef<ConsentModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) matDialogData: ConsentModalData,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) matBottomSheetData: ConsentModalData,
    translateService: TranslateService,
  ) {
    super(
      dialogRef as MatDialogRef<ConfirmationModalComponent>,
      bottomSheetRef as MatBottomSheetRef<ConfirmationModalComponent>,
      matDialogData,
      matBottomSheetData,
      translateService,
    );
    const data = matDialogData ?? matBottomSheetData;
    if (data?.consentCheckboxLabel) {
      this.consentCheckboxLabel = data.consentCheckboxLabel;
    }
  }
}
